export const INVITATIONS_LOADED = 'INVITATIONS_LOADED';
export const INVITATION_SENT = 'INVITATION_SENT';
export const RESENDING_INVITATION = 'RESENDING_INVITATION';
export const INVITATION_RESENT = 'INVITATION_RESENT';
export const INVITATION_DELETED = 'INVITATION_DELETED';
export const LOG_ERRORS = 'LOG_ERRORS';
export const TEAM_LOADED = 'TEAM_LOADED';
export const USER_LOADED = 'USER_LOADED';
